import { CopyIcon } from '../icons';

export function CopyLinkServer({ onClick, copied }: { onClick?: () => void; copied?: boolean }) {
  return (
    <button type="button" aria-label="Copy link" onClick={onClick} className="cursor-pointer">
      {copied ? (
        <span className="font-sans text-xl font-semibold leading-none text-brand-accent underline">
          Copied!
        </span>
      ) : (
        <span className="flex items-center gap-2 text-brand-accent">
          <CopyIcon className="size-[18px]" />
          <span className="font-sans text-xl font-semibold leading-none underline">Copy link</span>
        </span>
      )}
    </button>
  );
}
